// extracted by mini-css-extract-plugin
export default {"napsa-header":"Header_napsa-header__j9JlK","napsa-header__buttons":"Header_napsa-header__buttons__4GKAk"};